'use strict';

import {keyBy} from 'lodash'

angular.module('clientDashboardApp').factory('providerService', function ($q, $http) {

  class ProviderService {

    constructor() {
      this.providers = [];
      this.TYPE_REVIEWS = 'REVIEWS';
      this.TYPE_PULSE = 'PULSE';
      this.TYPE_REVIEW_RESPONSES = 'REVIEW_RESPONSES';
      this.TYPE_LISTINGS = 'LISTINGS';
      this.TYPE_LISTING_MANAGMENT = 'LISTING_MANAGEMENT'
    }

    allProviders(includeNonPublicProviders) {
      return this.providersRequest = $http
          .get(`/dashboard/providers/all`, {params: {includeNonPublicProviders: includeNonPublicProviders, includeUnassigned: true}})
          .then(response => {
              this.providers = response.data;
              return this.providers
            },
            fail => {
              this.providersRequest = undefined
              throw fail
            })
    }

    getProvider(id) {
      return this.providers.find(p => p.id === id)
    }

    displayNameFor(id) {
      const found = this.provider && this.providers.find(x =>
        x.id === id.toUpperCase() || (id.toUpperCase() === 'GOOGLEMAP' && x.id === 'GOOGLE')
      );
      if (!found) {
        return id.charAt(0).toUpperCase() + id.slice(1).toLowerCase();
      } else {
        return found.name;
      }
    }

    validProviders(groupId, type = this.TYPE_REVIEWS) {
      return $http
        .get(`/dashboard/providers/${type}/group/${groupId}`)
        .then(response => response.data)
    }

    validProvidersAndKeyedById(groupId, type) {
      return this.validProviders(groupId, type).then(providers => ({providers, providersById: keyBy(providers, 'id')}))
    }



  }




  return new ProviderService()
})
